import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../01_atoms/Button';
import Spinner from '../../01_atoms/Spinner';

import { PTButtonField, PTButtonFieldDefaults } from './prop-types';
import { formatAmount } from '../../../utils/currency';
import NextChevron from '../../../public/static/icons/navigation-chevron-right-white-thick.svg';

// TODO: use CSS modules.
class ButtonFieldNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovering: false,
      isLoading: false,
    };
  }

  onSubmit = (event) => {
    // Make sure that tabbing through the link doesn't fire the onClick.
    if (event.keyCode === 9) {
      return null;
    }

    const { value, currency, onSubmit, isDisabled, position } = this.props;

    if (isDisabled) {
      return null;
    }

    this.setState((state) => ({ ...state, isLoading: true }));

    return onSubmit({ value, currency, position }).then(() => {
      this.setState((state) => ({ ...state, isLoading: false }));
    });
  };

  render() {
    const { value, currency, description, buttonClassName, image, isDisabled } = this.props;
    const { isHovering, isLoading } = this.state;

    const cost = formatAmount(currency, value);

    return (
      <>
        <div
          className={`d-none d-lg-flex flex-column button-field-new desktop ${
            image ? 'type-image' : 'type-plain'
          } ${isLoading ? 'loading' : ''} ${isDisabled ? 'disabled' : ''}`}
          style={{
            backgroundImage: `${
              image
                ? `linear-gradient(to top, rgba(33,36,49,0.7) 0%, rgba(33,36,49,0) 100%), url("${image.url}")`
                : ''
            }`,
          }}
          title={image ? image.alt : ''}
          onMouseEnter={() => !isDisabled && !isLoading && this.setState({ isHovering: true })}
          onMouseLeave={() => !isLoading && this.setState({ isHovering: false })}
          onClick={this.onSubmit}
          onKeyDown={this.onSubmit}
        >
          {!image && <div className="title">{cost}</div>}

          {description && <p>{description}</p>}

          <Button
            className={`${buttonClassName} ${isHovering ? 'hover' : ''}`}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isUppercase
            withArrow
          >
            Donate&nbsp;{cost}
          </Button>
        </div>

        {image && image.url ? (
          <div
            className={`d-flex d-lg-none button-field-new mobile type-image ${
              isLoading ? 'loading' : ''
            } ${isDisabled ? 'disabled' : ''}`}
            onMouseEnter={() => !isDisabled && !isLoading && this.setState({ isHovering: true })}
            onMouseLeave={() => !isLoading && this.setState({ isHovering: false })}
            onClick={this.onSubmit}
            onKeyDown={this.onSubmit}
          >
            <div className="image-container">
              <img src={image.url} alt={image.alt} width={300} height={320} />
            </div>

            <div className="d-flex justify-content-center flex-column container">
              <div className="title">Donate&nbsp;{cost}</div>

              {description && <div className="description">{description}</div>}

              <NextChevron
                className={`chevron ${isLoading ? 'd-none' : ''} ${isHovering ? 'hover' : ''}`}
              />

              <Spinner className={`${!isLoading ? 'd-none' : ''}`} />
            </div>
          </div>
        ) : (
          <div
            className={`d-flex d-lg-none button-field-new mobile type-plain ${
              isLoading ? 'loading' : ''
            } ${isDisabled ? 'disabled' : ''}`}
            onMouseEnter={() => !isDisabled && !isLoading && this.setState({ isHovering: true })}
            onMouseLeave={() => !isLoading && this.setState({ isHovering: false })}
            onClick={this.onSubmit}
            onKeyDown={this.onSubmit}
          >
            <div className="d-flex align-items-center container">
              <div className="title">{cost}</div>

              {description && <div className="description">{description}</div>}

              <Button
                className={`${buttonClassName} ${isHovering ? 'hover' : ''}`}
                isDisabled={isDisabled}
                isUppercase
                withArrow
              >
                Donate
              </Button>
            </div>
          </div>
        )}
      </>
    );
  }
}

ButtonFieldNew.propTypes = {
  ...PTButtonField,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  currency: PTButtonField.currency.isRequired,
};

ButtonFieldNew.defaultProps = {
  ...PTButtonFieldDefaults,
  image: null,
};

export default ButtonFieldNew;
